import { cnpjValido } from './cnpj'

/** CNPJ numérico ou alfanumérico, com ou sem máscara (ver `@/utils/cnpj`). */
export const validateCNPJ = (cnpj: string): boolean => cnpjValido(cnpj)

export const validateCPF = (cpf: string): boolean => {
  const clean = cpf.replace(/\D/g, '')

  if (clean.length !== 11) return false
  if (/^(\d)\1{10}$/.test(clean)) return false

  let sum = 0
  let remainder = 0

  for (let i = 1; i <= 9; i++) {
    sum += parseInt(clean.substring(i - 1, i)) * (11 - i)
  }

  remainder = (sum * 10) % 11
  if (remainder === 10 || remainder === 11) remainder = 0
  if (remainder !== parseInt(clean.substring(9, 10))) return false

  sum = 0
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(clean.substring(i - 1, i)) * (12 - i)
  }

  remainder = (sum * 10) % 11
  if (remainder === 10 || remainder === 11) remainder = 0
  if (remainder !== parseInt(clean.substring(10, 11))) return false

  return true
}

export const validateEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(email)
}

export const validatePhone = (phone: string): boolean => {
  const clean = phone.replace(/\D/g, '')
  return clean.length >= 10 && clean.length <= 11
}

export const validateCEP = (cep: string): boolean => {
  const clean = cep.replace(/\D/g, '')
  return clean.length === 8
}

export const validatePositiveNumber = (value: number): boolean => {
  return value > 0
}
